import React, { Fragment } from 'react';
import LandlordIncentives from 'components/landlord_app/payments/LandlordIncentives';
import { featureEnabled } from 'helpers/ToggleBot';
import { Route } from 'react-router';
import CreateIncentive from 'components/landlord_app/payments/IncentiveManagement/CreateIncentive';
import EditIncentive from 'components/landlord_app/payments/IncentiveManagement/EditIncentive';

const getCreateRouteOrFallbackPage = (_, callback) => {
  const ComponentToRender = featureEnabled('ui.incentives.overhaul')
    ? CreateIncentive
    : LandlordIncentives;
  callback(null, ComponentToRender);
};

const getIncentiveByIdOrFallbackPage = (_, callback) => {
  const ComponentToRender = featureEnabled('ui.incentives.overhaul')
    ? EditIncentive
    : LandlordIncentives;
  callback(null, ComponentToRender);
};

const IncentiveManagementRoutes = (authenticateLandlord) => {
  return (
    <Fragment>
      <Route path="incentives" component={LandlordIncentives} onEnter={authenticateLandlord} />
      <Route
        path="incentives/new"
        getComponent={getCreateRouteOrFallbackPage}
        onEnter={authenticateLandlord}
      />
      <Route
        path="incentives/:incentiveId"
        getComponent={getIncentiveByIdOrFallbackPage}
        onEnter={authenticateLandlord}
      />
    </Fragment>
  );
};

export default IncentiveManagementRoutes;
